export default "__VITE_ASSET__U6vhRY0w__"